module.exports = __webpack_public_path__ + "img/56b19ae.png";